import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

export interface AssessmentTaskScopeChange {
    productLicenseId: number | null;
    source: "mutation" | "license_refresh";
}

@Injectable({ providedIn: "root" })
export class AssessmentTaskScopeChangesService {
    private readonly changes = new Subject<AssessmentTaskScopeChange>();

    watchChanges(): Observable<AssessmentTaskScopeChange> {
        return this.changes.asObservable();
    }

    assessmentChanged(productLicenseId: number, source: AssessmentTaskScopeChange["source"] = "mutation"): void {
        if (Number.isSafeInteger(productLicenseId) && productLicenseId > 0) {
            this.changes.next({ productLicenseId, source });
        }
    }

    accountChanged(): void {
        this.changes.next({ productLicenseId: null, source: "mutation" });
    }
}
